import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';

import { axios } from 'lib/axios';
import { enqueueSnackbar } from 'notistack';

const updateCompanyValidatedStatus = ({ companyId, validated }) => {
  return axios.put(`/api/companies/${companyId}/validated`, { validated });
};

export const useUpdateCompanyValidatedStatus = (refetch) => {
  let { id } = useParams();

  return useMutation({
    mutationFn: (validated) => updateCompanyValidatedStatus({ companyId: id, validated }),
    onSuccess: () => {
      enqueueSnackbar('Company validation status successfully updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      refetch();
    },
    onError: (error) => {
      console.log(error);
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
